// removed by extract-text-webpack-plugin
module.exports = {"lang-select":"lang-select--1hHZk","meta-nav-mobile":"meta-nav-mobile--37ZeF","meta-link":"meta-link--2-9oT","is-active":"is-active--2f42T"};


//////////////////
// WEBPACK FOOTER
// ./client/components/meta-nav-mobile/meta-nav-mobile.scss
// module id = 472
// module chunks = 0